/** Service categories (nhóm dịch vụ) — per-tenant managed catalog. */
import { apiClient } from "./client";

export interface ServiceCategory {
  id: string;
  code: string;
  name: string;
  sortOrder: number;
  /** Trạng thái: false = ngưng hoạt động (không còn chọn được khi sửa dịch vụ). */
  active: boolean;
  /** Hiển thị trên App — độc lập với trạng thái (giống SalePro `display` vs `status`). */
  displayOnApp: boolean;
}

export interface ServiceCategoryUpsert {
  name: string;
  sortOrder?: number | null;
  active?: boolean | null;
  displayOnApp?: boolean | null;
}

const BASE = "/v1/service-categories";

export const serviceCategoriesApi = {
  list(includeInactive = false): Promise<ServiceCategory[]> {
    return apiClient
      .get<ServiceCategory[]>(BASE, { params: { includeInactive } })
      .then((r) => r.data);
  },
  create(req: ServiceCategoryUpsert): Promise<void> {
    return apiClient.post<void>(BASE, req).then((r) => r.data);
  },
  update(id: string, req: ServiceCategoryUpsert): Promise<void> {
    return apiClient.put<void>(`${BASE}/${id}`, req).then((r) => r.data);
  },
  remove(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE}/${id}`).then((r) => r.data);
  },
};

export const serviceCategoryQueryKeys = {
  all: () => ["service-categories"] as const,
};
